/* eslint-disable */ import { materialSwatchComponent, memoEval, sceneEntityObjectRemoteMaterialOverrideComponent } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
import { LegsColorSteel } from '../model/index.js';
export const steelLegsComponents = [
    attachComponent.withComponent(sceneEntityObjectRemoteMaterialOverrideComponent, 'body', true).withAlias('SteelLegs').attach(memoEval((self)=>[
            self.$materialColor,
            self.$normalUrl,
            self.$roughnessMapUrl
        ], ($materialColor, $normalUrl, $roughnessMapUrl)=>({
            materialsToOverride: [
                'LegsMaterial'
            ],
            fileUrl: '/models/algu3d.glb',
            materialName: 'LegsMaterial',
            roughness: 1,
            color: $materialColor,
            normalMapUrl: $normalUrl,
            roughnessMapUrl: $roughnessMapUrl,
            normalScale: 1
        }))),
    attachComponent.withComponent(materialSwatchComponent, 'legsColor', true).withAlias('SteelLegs').attach(memoEval((self)=>[
            self.$legsColorSwatches,
            self.color
        ], ($legsColorSwatches, color)=>({
            swatches: $legsColorSwatches,
            selectedSwatchKey: color
        })), (state)=>{
        LegsColorSteel.assert(state.selectedSwatchKey);
        return {
            color: state.selectedSwatchKey
        };
    })
];

//# sourceMappingURL=steel-legs.js.map